import styled from 'styled-components';

export const StyledSpan = styled.span`
  width: 1rem;
`;
